import CustomFormBuilderEdit from "@/CustomForms/CustomFormBuilderEdit.vue";
import CustomFormBuilderNew from "@/CustomForms/CustomFormBuilderNew.vue";
import CustomFormsIndex from "@/CustomForms/CustomFormsIndex.vue";

export default [
  {
    path: "/company/custom_forms",
    name: "CustomFormsIndex",
    component: CustomFormsIndex,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/company/custom_forms/new",
    name: "CustomFormNew",
    component: CustomFormBuilderNew,
    meta: {
      permissionRoles: ["account_settings"]
    }
  },
  {
    path: "/company/custom_forms/:id/edit",
    name: "CustomFormEdit",
    component: CustomFormBuilderEdit,
    meta: {
      permissionRoles: ["account_settings"]
    }
  }
];
